/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * baseImgPath: 图片存放地址
 *

 */
let baseUrl = '';
let apiUrl = '';
let routerMode = 'history';


//let baseImgPath = 'http://106.53.81.229:5080/sy-img/';
//let uploadImgPath = "http://106.53.81.229:5080/sy-img/uploadImages?type=lansi";
//let deleteImgPath = "http://106.53.81.229:5080/sy-img/";
// let baseImgPath = 'https://mp.ch-blueocean.org/sy-img/';
// let uploadImgPath = "https://mp.ch-blueocean.org/sy-img/uploadImages?type=lansi";
// let deleteImgPath = "https://mp.ch-blueocean.org/sy-img/";
// let baseImgPath = 'https://www.sanyawlzyfw.com/sy-img/';
// let uploadImgPath = "https://www.sanyawlzyfw.com/sy-img/uploadImages?type=lansi";
// let deleteImgPath = "https://www.sanyawlzyfw.com/sy-img/";
// let baseImgPath = 'http://127.0.0.1:9090/';
// let uploadImgPath = "http://127.0.0.1:9090/uploadImages?type=zyz";
// let deleteImgPath = "http://127.0.0.1:9090/deleteImage?";
let baseImgPath = 'https://www.sanyawlzyfw.com/images/';
let uploadImgPath = "https://www.sanyawlzyfw.com/sy-img/uploadImages?type=zyz";
let deleteImgPath = "https://www.sanyawlzyfw.com/sy-img/deleteImage?";
let wxPath = "";
let adminUrl="http://localhost:8002";
if (process.env.NODE_ENV == 'development') {
	baseUrl = 'http://localhost:9098/';
	//baseUrl = 'http://106.53.81.229:5080/lansi-web-admin/';


}else{
	// baseUrl = 'https://mp.ch-blueocean.org/lansi-web-admin/';
	// adminUrl="https://mp.ch-blueocean.org";
	baseUrl = 'https://www.sanyawlzyfw.com/admin/';
	adminUrl="https://www.sanyawlzyfw.com";
	//baseUrl = 'http://nyzhonghe.i-sanya.com/nyzhonghe-web-admin/';
}

export {
	baseUrl,
    apiUrl,
	routerMode,
	baseImgPath,
	uploadImgPath,
    deleteImgPath,
    wxPath,
	adminUrl,
}



// WEBPACK FOOTER //
// ./src/config/env.js